import { useEffect } from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';

const MotionActions = ({ setMotionHeaderButtonProps, handleOpen }) => {
  const ctx = useTableContext();
  const { ModalComponent, newButtonText, title } = ctx;

  useEffect(() => {
    if (!!setMotionHeaderButtonProps) {
      setMotionHeaderButtonProps({
        onClick: () => handleOpen(true),
        text: newButtonText || `New ${title}`
      });
    }

    return () => {
      setMotionHeaderButtonProps(null);
    };
  }, [ModalComponent, setMotionHeaderButtonProps]);

  return null;
};

export default MotionActions;
